<template>
 <div style="flex:1 0 auto;position:relative;" v-if="canRender">
    <v-card class="ma-2 maincontent" >      
      <v-card-title style="flex-direction:column;align-items:stretch;height:100%;">        
         <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
          <v-flex class="inline-block px-4">
              <h2 class="ml-0" style="flex:0 0 auto;">{{$t('Admin.MsgAccueil.FullTitle')}}</h2>         
              <v-textarea                   
                :label="$t('Admin.MsgAccueil.Text')"
                v-model="configMsgAccueil.message"                    
                rows="10"
                auto-grow
            ></v-textarea>            
            <h2 class="ml-0" style="flex:0 0 auto;">{{$t('Admin.MsgAccueil.Planification')}}</h2>         
            <v-switch hide-details  v-model="configMsgAccueil.usePlanif" :label="$t('Admin.MsgAccueil.UsePlanif')"></v-switch>            
            <div v-if="configMsgAccueil.usePlanif" class="d-flex align-end">{{$t('Admin.MsgAccueil.StartShow')}} <v-select class="ml-2 flex-grow-0" hide-details :items="daysWeek" item-text="label" v-model="configMsgAccueil.startDay" ></v-select> <input class="ml-2 flex-grow-0" type="time" v-model="configMsgAccueil.startUtcTime" /></div>
            <div v-if="configMsgAccueil.usePlanif" class="d-flex align-end">{{$t('Admin.MsgAccueil.EndShow')}} <v-select  class="ml-2 flex-grow-0" hide-details :items="daysWeek" item-text="label" v-model="configMsgAccueil.endDay" ></v-select> <input class="ml-2 flex-grow-0" type="time" v-model="configMsgAccueil.endUtcTime" /></div>            
          </v-flex>                                   
        </v-layout>          
        <v-layout class="pt-2 adm-button" row wrap >          
          <v-btn :disabled="loading || !modified" @click.prevent="annuler">{{$t('Admin.Cancel')}}<v-icon right>mdi-restore</v-icon></v-btn>
          <v-btn :disabled="loading || !modified" @click.prevent="sauvegarde">{{$t('Admin.Save')}}<v-icon right>mdi-content-save</v-icon></v-btn>
        </v-layout>          
      </v-card-title>          
    </v-card> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import {MsgAccueil} from '@/models/datapool/MsgAccueil'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
import deepEqual from 'deep-equal'
import { SecurityItemsKeys } from '@/enum/SecurityItems'



@Component({
  name: 'AdminMsgAccueil'  
})
export default class AdminMsgAccueil extends Vue {      
    
  loading = false
  canRender = true
  status = ""
  configMsgAccueil = new MsgAccueil()

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_MESSAGE_LOGIN].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get modified() {
    return !deepEqual(this.originalMsgAccueil,this.configMsgAccueil)
  }

  get originalMsgAccueil(){
    return MsgAccueil.createMsgAccueil(this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.msgAccueil']))
  }

  get daysWeek() {
    return ["Sunday", "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"].map((it,idx) => ({value:idx,label:it}) )
  }  

  mounted(){
    this.loading = true
    this.status = this.$t('Admin.MsgAccueil.Loading').toString()
    this.$store.myActions.DATAPOOL_ENSURE({fullKey:DataPoolGlobalKeys['global.config.msgAccueil']}).then(()=> {
      this.annuler()
      this.status = this.$t('Admin.MsgAccueil.Loaded').toString()
    }).finally(()=>{
      this.loading = false;
    });    
  }

  

  /*Fonctions*/  
  sauvegarde() {
    //@ts-ignore
    this.status = this.$t('Admin.MsgAccueil.Loading').toString()
    this.loading = true
    this.$store.myActions.DATAPOOL_UPDATE_REQUEST(
        new AloDataPoolItem({
        dtaValue:JSON.stringify(this.configMsgAccueil),
        dtaKey:DataPoolGlobalKeys['global.config.msgAccueil']
      })).then((data)=>{
        this.status = this.$t('Admin.MsgAccueil.Loaded').toString()
        this.annuler()
      }).finally(()=>{
        this.loading = false
      })      
  }
  
  annuler() {
    //@ts-ignore
    this.configMsgAccueil = new MsgAccueil(this.originalMsgAccueil)
  }

}
</script>